import React from "react"
import StyledMenu from "./Menu.style"
import { Link, navigate } from "gatsby"
import Logo from "../../atoms/Logo/Logo"
import { randomID, isInternal, relativeNonHook } from "../../particles/helpers"
import useRelative from "../../particles/hooks/useRelative"

const getSubmenuPadding = () => {
  let menu: HTMLElement =
    typeof window === "undefined" || !window.document
      ? null
      : document.querySelector(".main-menu ul")
  let paddingTop = 40

  if (menu !== null) {
    let menuLi: HTMLElement = menu.querySelector("li")
    if (menuLi !== null) {
      let menuHeight = menu.offsetHeight
      let menuLiHeight = menuLi.offsetHeight

      paddingTop = (menuHeight - menuLiHeight) / 2
    }
  }

  return paddingTop
}

const navigateMobile = (link, onclick) => {
  onclick()
  isInternal(link)
    ? navigate(relativeNonHook(link))
    : window.open(link, "_blank")
}

// there is an issue in Gatsby v3 where hovering over links causes page refresh
// this makes the menu pretty glitchy; I believe this is a development-only bug and does not happen with a production build
const Menu = ({ fontColor, logo, menuItems, mobile, onClick }: Props) => {
  // Graphql now returns every menuItem as a node, even if it is a subitem; remove the subitem nodes
  menuItems = menuItems.filter(item => !item.parentId)

  return (
    <StyledMenu fontColor={fontColor} mobile={mobile || undefined}>
      {menuItems.map((menuItem, idx) => (
        <li
          key={randomID()}
          onClick={
            mobile
              ? () => {
                  navigateMobile(menuItem.url, onClick)
                }
              : undefined
          }
          style={{
            order: idx,
            position:
              menuItem.cssClasses[0] === "mm" ? undefined : `relative`,
          }}
        >
          {isInternal(menuItem.url) ? (
            <Link
              to={useRelative(menuItem.url)}
              className={
                menuItem.cssClasses[0] === "mm" ? "no-line" : menuItem.cssClasses
              }
              activeClassName={
                fontColor === "#fff" ||
                fontColor === "#ffffff" ||
                fontColor === "white"
                  ? `underlineActive`
                  : `primaryActive`
              }
              key={randomID()}
            >
              {menuItem.label}
            </Link>
          ) : (
            <a
              href={!mobile ? menuItem.url : undefined}
              className={ menuItem.cssClasses.join(" ") }
              target="_blank"
              rel="noopener"
              key={randomID()}
            >
              {menuItem.label}
            </a>
          )}

          {menuItem.childItems ? (
            <ul
              className={menuItem.cssClasses[0]}
              style={{ paddingTop: `${getSubmenuPadding()}px` }}
            >
              {menuItem.childItems.nodes.map(childItem => {
                if (!childItem.childItems.nodes.length) {
                  return (
                    <Link to={useRelative(childItem.url)} key={randomID()}>
                      <li key={randomID()}>{childItem.label}</li>
                    </Link>
                  )
                } else {
                  // This is the Mega Menu code
                  return (
                    <li
                      key={randomID()}
                      style={{
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      {childItem.label}
                      <ul>
                        {childItem.childItems.nodes.map(t => {
                          if (childItem.cssClasses[0]) {
                            let cssClass = childItem.cssClasses[0].split("_")
                            let givenUrl = t.url.split("/")
                            let newUrl = ""

                            if (cssClass[0] === "link") {
                              newUrl = `/${cssClass.slice(1).join("/")}/${
                                givenUrl[4]
                              }`
                            }

                            return (
                              <li key={randomID()}>
                                <Link to={useRelative(newUrl)}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: t.label,
                                    }}
                                  />
                                </Link>
                              </li>
                            )
                          } else {
                            return (
                              <li key={randomID()}>
                                <Link to={useRelative(t.url)}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: t.label,
                                    }}
                                  />
                                </Link>
                              </li>
                            )
                          }
                        })}
                      </ul>
                    </li>
                  )
                }
              })}
            </ul>
          ) : null}
        </li>
      ))}
      {logo ? (
        <Link
          to="/"
          className="no-line"
          key={randomID()}
          style={{ order: menuItems.length / 2 - 1 }}
        >
          <Logo height={100} maxWidth={150} />
        </Link>
      ) : (
        ``
      )}
    </StyledMenu>
  )
}

type Props = {
  fontColor: string
  menuItems: any
  logo?
  mobile?
  onClick?: () => void
}

export default Menu
